import $ from 'jquery';
window.$ = window.jQuery = $; // Expose jQuery to the global object at public page
import topSettings from './_top.js';
import itemDetail from './_item-detail.js';
import registerTerms from './_register-terms.js';
import mypage from './_mypage.js';
import login from './_login.js';
import contact from './_contact.js';
import register from './_register.js';
import about from './_about.js';
import productions from './_productions.js';
import pre from './_pre.js';
import faq from './_faq.js';
import staticPage from './_static-page.js';
import modalScript from './_modal.js';

const init = () => {
  settings();
}

const settings = () => {
  cartHeightAdjust();
  cartSetting();
  searchSetting();
  menuSetting();
  spMenuAccordion();
  myAccountBtn();
  $(window).on('resize', cartHeightAdjust);
  if($('body').hasClass('top-page')){ topSettings(); }
  if($('body').hasClass('item-detail')){ itemDetail(); }
  if($('body').hasClass('register-terms')){ registerTerms(); }
  if($('body').hasClass('mypage')){ mypage(); }
  if($('body').hasClass('contact')){ contact(); }
  if($('body').hasClass('register')){ register(); }
  if($('body').hasClass('about')){ about(); }
  if($('body').hasClass('produtions')){ productions(); }
  if($('body').hasClass('login')){ login(); }
  if($('body').hasClass('pre')){ pre(); }
  if($('body').hasClass('faq')){ faq(); }
  if($('body').hasClass('static-page')){ staticPage(); }
}

const cartSetting = () => {
  $(".cart-btn").on("click", cartOpen);
  $(".close-cart-button").on("click", cartClose);
}
const searchSetting = () => {
  const searchButton = $(".search-button");
  searchButton.on("click", () => {
    if (searchButton.hasClass('is-open')) {
      searchClose();
      searchButton.removeClass('is-open');
    } else {
      searchOpen();
      searchButton.addClass('is-open');
    }
    return false;
  });
}
const menuSetting = () => {
  $(".menu-btn").on("click", menuOpen);
  $(".js-close-menu, .js-menu-list-bg").on("click", menuClose);
  $(".openCart-fromSpMenu").on("click", function(e){
    $("#menu-list").removeClass('opened');
    $("#mycart").addClass('opened');
    return false;
  })
}
const cartOpen = (e) => {
  $("#mycart").addClass('opened');
  modalScript.open();
  return false;
}
const cartClose = (e) => {
  if($("#mycart").hasClass('opened')){
    $("#mycart").removeClass('opened').addClass('closed');
    modalScript.close();
  }
  return false;
}

const menuOpen = (e) => {
  $("#menu-list").addClass('opened');
  modalScript.open();
  return false;
}
const menuClose = (e) => {
  $("#menu-list").removeClass('opened').addClass('closed');
  modalScript.close();
  return false;
}

const searchOpen = (e) => {
  $("#item-search").addClass('opened');
  return false;
}
const searchClose = (e) => {
  $("#item-search").removeClass('opened').addClass('closed');
  return false;
}

const spMenuAccordion = () => {
  $(".js-menu-list-accordion-btn").on("click", function(){
    $(this).toggleClass('is-open');
    $(this).next(".js-menu-list-accordion-content").toggleClass('is-open');
  });
}

const cartHeightAdjust = () => {
  if( getiOSVersion() < 15.4 ){
    $("#mycart").css({ "height" : window.innerHeight+"px"});
  }
}

const myAccountBtn = () => {
  var myAccountBtn = $(".js-my-account-btn");

  $(window).on('scroll', function() {
    var footerHeight = $('.js-footer-inner').innerHeight();
    var scrollableAmount = $(document).height() - ($(window).scrollTop() + window.innerHeight);

    if (scrollableAmount < footerHeight) {
      myAccountBtn.css({
        position: 'absolute',
        bottom: (footerHeight + 20) + 'px'
      });
    } else {
      myAccountBtn.css({
        position: '',
        bottom: ''
      });
    }
  });
}

const getiOSVersion = () => {
  return parseFloat(
      ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
      .replace('undefined', '3_2').replace('_', '.').replace('_', '')
  ) || false;
}
init();
